/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserTasks = /* GraphQL */ `
  query GetUserTasks($User: String!) {
    getUserTasks(User: $User) {
      User
      TaskName
      Description
      DateCreated
      TaskRunTime
      TaskStatus
    }
  }
`;
